import React from "react";
import Sidebar from "../components/Sidebar";

const Support: React.FC = () => {
  return (
    <div className="flex min-h-screen bg-gray-100">
      <Sidebar />
      <div className="flex-1 p-8">
        <div className="max-w-7xl mx-auto">
          <h1 className="text-3xl font-bold text-gray-900 mb-2">ศูนย์ช่วยเหลือ</h1>
          <p className="text-gray-600 mb-6">ติดต่อและรับการสนับสนุน</p>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="bg-white rounded-lg shadow p-6 border border-gray-200">
              <h2 className="text-xl font-semibold text-gray-900 mb-4">ติดต่อเรา</h2>
              <div className="space-y-4">
                <div>
                  <p className="text-sm text-gray-600">อีเมล</p>
                  <p className="text-base text-gray-900">support@comex.com</p>
                </div>
                <div>
                  <p className="text-sm text-gray-600">เบอร์โทร</p>
                  <p className="text-base text-gray-900">02-123-4567</p>
                </div>
                <div>
                  <p className="text-sm text-gray-600">ไลน์</p>
                  <p className="text-base text-gray-900">@comex</p>
                </div>
              </div>
            </div>

            <div className="bg-white rounded-lg shadow p-6 border border-gray-200">
              <h2 className="text-xl font-semibold text-gray-900 mb-4">ส่งข้อความ</h2>
              <div className="space-y-4">
                <input type="text" placeholder="ชื่อ" className="w-full px-4 py-2 border border-gray-300 rounded-lg" />
                <input type="email" placeholder="อีเมล" className="w-full px-4 py-2 border border-gray-300 rounded-lg" />
                <textarea placeholder="ข้อความ" rows={4} className="w-full px-4 py-2 border border-gray-300 rounded-lg" />
                <button className="w-full bg-blue-600 text-white py-2 rounded-lg hover:bg-blue-700 transition-colors">
                  ส่งข้อความ
                </button>
              </div>
            </div>

            <div className="bg-white rounded-lg shadow p-6 border border-gray-200 md:col-span-2">
              <h2 className="text-xl font-semibold text-gray-900 mb-4">คำถามที่พบบ่อย</h2>
              <div className="space-y-4">
                <div className="border-b border-gray-200 pb-4">
                  <h3 className="font-medium text-gray-900 mb-2">วิธีใช้ PromptPay อย่างไร?</h3>
                  <p className="text-sm text-gray-600">สแกน QR Code ด้วยแอปพลิเคชันธนาคารของคุณและทำการชำระเงิน</p>
                </div>
                <div className="border-b border-gray-200 pb-4">
                  <h3 className="font-medium text-gray-900 mb-2">เวลาดำเนินการชำระเงินนานเท่าไร?</h3>
                  <p className="text-sm text-gray-600">โดยทั่วไป 1-3 นาที หลังจากสแกน QR Code</p>
                </div>
                <div>
                  <h3 className="font-medium text-gray-900 mb-2">ติดต่อฝ่ายสนับสนุนได้อย่างไร?</h3>
                  <p className="text-sm text-gray-600">ติดต่อทางอีเมล support@comex.com หรือโทร 02-123-4567</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Support;
